import axiosInstance from "auth/FetchInterceptor";
import {
  SEARCH_ORDER,
  GET_ORDER_DETAIL,
  GET_ORDER_TIMELINE,
  CREATE_ORDER,
  UPDATE_ORDER,
  CANCEL_ORDER,
  RECALCULATE_PRICE,
  GET_CANCEL_PREVIEW,
  ORDER_COUNT_BY_STATUS,
  ORDER_MARK_REFUND,
  ORDER_PREVIEW_PRICE,
} from "constants/ApiConstant";

const OrderService = {};

OrderService.searchOrder = function (data) {
  return axiosInstance.post(SEARCH_ORDER, data);
};

OrderService.getOrderDetail = function (orderId) {
  return axiosInstance.get(`${GET_ORDER_DETAIL}/${orderId}`);
};

OrderService.getOrderTimeline = function (orderId) {
  return axiosInstance.get(`${GET_ORDER_TIMELINE}/${orderId}`);
};

OrderService.createOrder = function (data) {
  return axiosInstance.post(CREATE_ORDER, data);
};

OrderService.updateOrder = function (data) {
  return axiosInstance.put(UPDATE_ORDER, data);
};

OrderService.cancelOrder = function (data) {
  return axiosInstance.post(CANCEL_ORDER, data);
};

OrderService.recalculatePrice = function (data) {
  return axiosInstance.post(RECALCULATE_PRICE, data);
};

OrderService.getCancelPreview = function (orderId) {
  return axiosInstance.get(`${GET_CANCEL_PREVIEW}/${orderId}`);
};

OrderService.getOrderCountByStatus = function (data) {
  return axiosInstance.post(ORDER_COUNT_BY_STATUS, data);
};

OrderService.markRefund = function (data) {
  return axiosInstance.post(ORDER_MARK_REFUND, data);
};

OrderService.previewPrice = function (data) {
  return axiosInstance.post(ORDER_PREVIEW_PRICE, data);
};

export default OrderService;